module.exports = __webpack_public_path__ + "static/media/video.2db43ae7.mp4";